import { ModalBox, StyledButton } from './styles';

import Icon from '@icons';
import Modal from '@material-ui/core/Modal';
/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';
/**
 * ReactDOM é um pacote que fornece métodos específicos do DOM que podem
 * ser usados no nível superior do seu aplicativo e como uma saída de 
 * emergencia para sair do modelo React.
 */
import ReactDOM from 'react-dom';

/**
 * ReactDOM.render() função recebe dois argumentos, codigo HTML e um 
 * elemento html, a função tem como objetivo exibir o codigo HTML espe-
 * cificado dentro do elemento HTML especificado.
 */
const onClose = () => {
  ReactDOM.render(null, document.getElementById('alert'));
};

/**
 * Confirm é um substituto do window.confirm() nativo do javascript com
 * a diferença de que esse está estilizado em um modal com a identidade
 * visual do projeto. Apenas um confirm por vez pode ser disparado e ele
 * pode ter um callback ao confirmar.
 */
export const ModalImport = ({
  callback,
  finallyCallback,
}) => {
  const closeAndCallback = (boolean, replaceOrAdd) => {
    if (boolean === true && callback && typeof callback === 'function' && replaceOrAdd === 'replace') {
      callback('replace');
    }
    if (boolean === true && callback && typeof callback === 'function' && replaceOrAdd === 'add') {
      callback('add');
    }
    if (boolean === false || typeof boolean === 'undefined') {
      callback(false);
    }
    if (finallyCallback && typeof finallyCallback === 'function') {
      finallyCallback();
    }
    onClose();
  };

  /**
   * Estrutura do componente Confirm modal com
   * identidade visual do projeto
   */
  return (
    <Modal style={{ zIndex: 2000 }} open={true} onClose={closeAndCallback}>
      <ModalBox>
        <button onClick={closeAndCallback} className="close">
          <Icon i="all-close" />
        </button>
        <header>
          <h2>Importar projeto</h2>
        </header>
        <div className="content"><p>O projeto importado deve substituir as camadas da lista de camadas ou ser adicionado?</p></div>
        <footer>
          <StyledButton
            variant="contained"
            color="primary"
            onClick={() => closeAndCallback(true, "replace")}
          >
            Substituir
          </StyledButton>
          <StyledButton
            variant="contained"
            color="primary"
            onClick={() => closeAndCallback(true, "add")}
          >
            Adicionar
          </StyledButton>
        </footer>
      </ModalBox>
    </Modal>
  );
};

ModalImport.propTypes = {
  /** Titulo do Confirm */
  title: PropTypes.string.isRequired,
  /** Mensagem do Confirm */
  message: PropTypes.string.isRequired,
  /** Função de callback: `function(confirmed)` */
  callback: PropTypes.func,
  /** Função de callback que executara independente da confirmação */
  finallyCallback: PropTypes.func,
  /** Texto do botão do Confirm */
  buttonText: PropTypes.string,
};

export default ModalImport;
